export default __webpack_public_path__ + "static/media/contact-img.8af525b2.svg";